<div class="justification-note__title">
    <img class="icons" [src]="ICONS.FILE_TEXT" alt="" />
    <h6 class="text-with-badge">
        {{ field.templateOptions.options[0].otherInfo.title1 }}
        <small class="note-subtitle">
            {{ field.templateOptions.options[0].otherInfo.title2 }}
        </small>
    </h6>
    <span class="badge-pill">
        {{ field.templateOptions.options[0].otherInfo.notesCount }}
    </span>
</div>
<div class="justification-note__history">
    <ul *ngIf="field.templateOptions.options[0].otherInfo.notesCount > 0">
        <li *ngFor="let item of field.templateOptions.options[0].ListItems" style="width: 100%">
            <p>
                {{ item.justificationNotes
                }}
                <span class="d-block color-orange">
                    <small>
                        {{ fnActionString(item) }}
                    </small>
                </span>
            </p>
        </li>
    </ul>
    <div class="no-notes" *ngIf="field.templateOptions.options[0].otherInfo.notesCount <= 0">
        <p class="no-notes-text">{{ "no_notes_available" | translate: param }}</p>
    </div>
</div>